<div class="modal-content">
  <div
    class="cross-icon info-modal-cross-icon"
    *ngIf="(showCrossBtn && !buttonField?.label) || showCrossBtnImp"
    (click)="closeModal(true)"
  >
    <em class="icon-liteicon-close"></em>
  </div>
  <div class="info">
    <div *ngIf="icomoonClass; icon">
      <app-circle-background-icon
        [icomoonClassName]="icomoonClass"
        iconSize="30px"
        backgroundCircleDiameter="80px"
        iconSizeMobile="30px"
        backgroundCircleDiameterMobile="80px"
      ></app-circle-background-icon>
    </div>
    <ng-template #icon>
      <div *ngIf="icon" [class]="iconStyleClass">
        <img class="icon" appDisableRightClick appMobileOptimization [originalUrl]="icon" [src]="icon" [format]="'webp'" alt="icon" loading="lazy" decoding="async">
      </div>
    </ng-template>
    <div *ngIf="heading" class="mt-4" [ngClass]="headerClass || ''">
      <h3 class="heading">{{ heading }}</h3>
    </div>
    <div *ngIf="description" class="mt-2" [ngClass]="descriptionClass || ''">
      <p class="description" [innerHTML]="description"></p>
    </div>
    <div *ngIf="subLabel" class="mt-4">
      <p class="sub-label">{{ subLabel }}</p>
    </div>
    <div *ngIf="buttonField?.label" class="mt-4">
      <app-button
        (handleButtonClick)="closeModal()"
        [btnField]="buttonField"
      ></app-button>
    </div>
  </div>
</div>
